import { EInternalPackageType, TAppState } from '../../types';
import { selectPackageInternalType } from '../buyPackageModal';
import { selectBuyCustomPackageAnalyticsLabel } from './selectBuyCustomPackageAnalyticsLabel';

const PACKAGE_LABELS: Record<EInternalPackageType, string> = {
  [EInternalPackageType.LegacyPackage]: 'BuyOffer',
  [EInternalPackageType.Package]: 'BuyOffer',
  [EInternalPackageType.Subscription]: 'BuyOffer',
  [EInternalPackageType.SubscriptionPublication]: 'BuyOffer',
  [EInternalPackageType.PersonalPackage]: 'BuyPersonalOffer',
  [EInternalPackageType.PersonalSubscription]: 'BuyPersonalOffer',
  [EInternalPackageType.PersonalSubscriptionPublication]: 'BuyPersonalOffer',
  [EInternalPackageType.SmartPackage]: 'BuyPersonalSmartOffer',
  [EInternalPackageType.CustomPackage]: 'BuyCustomOffer',
} as const;

export const selectAnalyticsLabel = (state: TAppState): string => {
  const internalType = selectPackageInternalType(state);

  if (internalType === EInternalPackageType.CustomPackage) {
    return selectBuyCustomPackageAnalyticsLabel(state);
  }

  return PACKAGE_LABELS[internalType];
};
